













































































import MixinMainWindow from '@/components/Cartable/ComponentMixins/MixinMainWindow';
import store from '@/store';
import {Component, Mixins} from 'vue-property-decorator'
import ChangePassword from '@/components/Cartable/ChangePassword/ChangePassword.vue';


@Component({
    components:{ChangePassword}
})
export default class MainWindow extends Mixins(MixinMainWindow) {
   
   shallShowChangePassword= false;
    created(){
        store.state.eventHub.$on('change-password',this.onOpenChangePassword);
        store.state.eventHub.$on('close-finalizeLetter',this.onCloseFinalizeLetter);
        
    }

    onOpenChangePassword(){
        this.shallShowChangePassword= true;
    }
    
    onCloseChangePassword(){
        this.shallShowChangePassword= false;
    }

    onCloseFinalizeLetter(){
        this.leftSideMode=''
    }
}

